'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextualTransformer = void 0;
var tslib_1 = require("tslib");
var ContextualTransformer = /** @class */ (function () {
    function ContextualTransformer(context) {
        this.context = context;
    }
    /**
     * Трансформирует фильтры настроек для браузера.
     *
     * Не мутирует настройку.
     * Возвращает новую настройку, если были изменения.
     *
     * @param {ISetting} setting - настройка
     * @returns {ISetting}
     * @memberof SettingTransformer
     */
    ContextualTransformer.prototype.transform = function (setting) {
        var filter = setting.filter;
        if (filter.unique_by_request) {
            if (this.context.instanceId) {
                filter = tslib_1.__assign(tslib_1.__assign({}, filter), { 'instance-id': this.context.instanceId });
            }
            else {
                filter = tslib_1.__assign(tslib_1.__assign({}, filter), { 'request-id': this.context.requestId });
            }
        }
        if (filter === setting.filter) {
            return setting;
        }
        return tslib_1.__assign(tslib_1.__assign({}, setting), { filter: filter });
    };
    return ContextualTransformer;
}());
exports.ContextualTransformer = ContextualTransformer;
//# sourceMappingURL=ContextualTransformer.js.map
